
import Vue from 'vue'
import { mapState } from 'vuex'
import { ProjectState, ProjectPath, ProjectRow } from '../channel.types'

import ActivityDescription from './ActivityDescription.vue'
import ActivityImage from './ActivityImage.vue'
import PlayButton from './buttons/PlayButton.vue'
import ActionButtons from './ActionButtons.vue'

export default Vue.extend({
  props: {
    path: Object,
  },

  components: {
    ActivityImage,
    ActivityDescription,
    PlayButton,
  },

  mounted() {
    const el = this.$refs.el as HTMLElement
    this.$emit('update', el.offsetHeight)
    this.scrollIntoView()
  },

  beforeDestroy() {
    this.$emit('update', 0)
  },

  computed: {
    rowLayout() {
      return this.path.row.layout || 'carousel'
    },

    ...mapState({
      article: state => (<ProjectState>state).selection.activity.description,
      loading: state =>
        (<ProjectState>state).article_engagements.article_loading,
    }),
  },

  methods: {
    scrollIntoView() {
      const el = this.$refs.el as Element
      if (el) {
        window.setTimeout(() => {
          el.scrollIntoView({
            behavior: 'smooth',
          })
        }, 100)
      }
    },
  },
})
